module.exports = __webpack_public_path__ + "static/media/5.2.3e65510d.png";